import ApiService from './api.service';

class TentService {
  async list() {
    try {
      const response = await ApiService.get('/tent');
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async create(tentData) {
    try {
      const response = await ApiService.post('/tent/add', tentData);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async update(tentData) {
    try {
      const response = await ApiService.put('/tent/update', tentData);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async delete(tentId) {
    try {
      const response = await ApiService.delete('/tent/delete', { id: tentId });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async exportTentSalesExcel() {
    try {
      const filename = `ventes-tentes-${new Date().toISOString().split('T')[0]}.xlsx`;
      await ApiService.downloadFile('/export/tent-sales/excel', filename);
    } catch (error) {
      throw error;
    }
  }
}

export default new TentService(); 